import {useUpdateHeaderTitle, usePermission} from "../hooks";
import {Header} from "../components/layout/header";
import React from "react";
import styled from "styled-components";
import {Tabs, Table as AntTable } from "antd";
import {useGetOrders} from "../pages-lib/stuck-orders/model";
import {getFormattedItems} from "../pages-lib/stuck-orders/model/use-get-orders";
import {getColumns} from "../pages-lib/stuck-orders/table-columns";
import {ClearOutlined} from "@ant-design/icons";
import {Button} from "../components/actions/button";

const STUCK_ORDER_TYPE = [
    {
        label: "В работе",
        value: "inProcessing",
        key: "inProcessing"
    },
    {
        label: "Оплачен",
        value: "paid",
        key: "paid"
    },
    {
        label: "Ожидает оплаты",
        value: "awaitingPayment",
        key: "awaitingPayment"
    },
    {
        label: "Ошибка ОФД",
        value: "errorOfd",
        key: "errorOfd"
    },
    {
        label: "Ошибка ТИЛИ",
        value: "errorTily",
        key: "errorTily"
    }
]

export default function StuckOrders() {
    const { hasPermission } = usePermission()
    const [ activeTabKey, setActiveTabKey ] = React.useState(STUCK_ORDER_TYPE[0].key)

    const {
        items,
        pagination,
        isLoading,
        getItems,
        handleTableChange,
        handleClearSchedulerCache
    } = useGetOrders()

    React.useEffect(() => {
        if (activeTabKey) {
            getItems(activeTabKey)
        }
    }, [activeTabKey])

    const headerTitle = useUpdateHeaderTitle({
        items,
        defaultTitle: "0 Заказов",
        arrType: ["Заказ", "Заказы", "Заказов"],
    })

    const columns = getColumns()

    return (
        <>
            <Header
                title={headerTitle}
            />


            <ButtonsRowFlex>
                <StyledButton
                    color={"#808080"}
                    onClick={handleClearSchedulerCache}
                    icon={<ClearOutlined style={{ fontSize: "16px"}}/>}
                >
                    {"Очистить кеш"}
                </StyledButton>
            </ButtonsRowFlex>

            <StyledTabs
                items={STUCK_ORDER_TYPE}
                activeKey={activeTabKey}
                onChange={(value) => setActiveTabKey(value)}
                type="line"
                size="large"
            />

            {activeTabKey &&
                <StyledTable
                    dataSource={getFormattedItems(items)}
                    columns={columns}
                    pagination={pagination}
                    loading={isLoading}
                    onChange={(e) => handleTableChange(e, activeTabKey)}
                />
            }
        </>
    )
}

const StyledTabs = styled(Tabs)`
  overflow: visible;
  margin-top: 20px;

  &.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
    border-bottom: none;
    user-select: none;
  }

  &.ant-tabs-card.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab {
    padding: 3px 7px 6px;
  }

  &.ant-tabs-top > .ant-tabs-nav {
    bottom: -3px;
    margin-bottom: 0;

    &::before {
      border-bottom: none;
    }
  }

  .ant-form-item {
    margin-bottom: 0;
  }
`

const StyledTable = styled(AntTable)`
  margin-top: 40px;
  .row-can-view {
    cursor: pointer;
  }
`

const ButtonsRowFlex = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
`

const StyledButton = styled(Button)`
    margin: 10px 0 0 0 ;
`;